//NavTabs
import NavTabs from "../../../components/NavBars/NavTabs/NavTabs";
//Components
import TableChoferes from "./components/index/TableChoferes";
import FormCompanies from "../EntidadesSecundarias/Empresas/FormCompanies";

const Choferes = () => {
  const sections = [
    { name: "Choferes", component: <TableChoferes /> },
    { name: "Empresas", component: <FormCompanies /> },
  ];
  return (
    <div className="custom-container">
      <h2>
        <b>Choferes Terminales y Servicios</b>
      </h2>
      <NavTabs sections={sections} />
    </div>
  );
};

export default Choferes;
